/*------------------------------------*\
    MODULES
\*------------------------------------*/
// import $ from "jquery";
import mediumZoom from 'medium-zoom';

/*------------------------------------*\
    ZOOMED IMG
\*------------------------------------*/
class ZoomedImg {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;


    }

    init() {
        let self = this;

        const img = self.elem.querySelectorAll('[zoomed-img]');

        let screenWidth = window.innerWidth;

        self.elem.children[0].addEventListener("click", (e) => {
            img.click();
        });

        document.getElementById('zoom-btn').addEventListener("click", (e) => {
            document.getElementById('zoomed-img').click();
        });

        if (screenWidth > 761) {
            mediumZoom(img);
        }

    }

}

export default ZoomedImg;